import Model, { attr, belongsTo } from '@ember-data/model';
import type { AsyncBelongsTo } from '@ember-data/model';
import { isBefore, subDays } from 'date-fns';
import type GroupInvite from 'garaje/models/group-invite';

export default class GroupInviteLink extends Model {
  static calculateDefaultExpiresAt(seedDate: Date | null): Date {
    const now = new Date();
    const latestValidDate = seedDate || now;
    const linkExpiresAt = subDays(latestValidDate, 1);
    const isShortNotice = isBefore(linkExpiresAt, now);

    return isShortNotice ? latestValidDate : linkExpiresAt;
  }

  @attr('string') declare name: string;
  @attr('string') declare publicToken: string;
  @attr('string') declare publicUrl: string;
  @attr('date') declare expiresAt: Date | null;
  @attr('number') declare capacityLimit: number | null;
  @attr('number') declare consumedCount: number;
  @attr('number') declare remainingCapacity: number;
  @attr('boolean') declare additionalGuests: boolean;
  @attr('boolean') declare active: boolean;
  @attr('date') declare lastHeartbeatAt: Date | null;
  @attr('date') declare createdAt: Date;
  @attr('date') declare updatedAt: Date;

  @belongsTo('group-invite', { async: true, inverse: 'groupInviteLinks' })
  declare groupInvite: AsyncBelongsTo<GroupInvite>;

  get isExpired(): boolean {
    if (!this.expiresAt) return false;
    return new Date() >= this.expiresAt;
  }

  get hasCapacity(): boolean {
    if (this.capacityLimit === null) return true;
    return this.remainingCapacity > 0;
  }

  get isAvailable(): boolean {
    return this.active && !this.isExpired && this.hasCapacity;
  }

  get groupInviteId(): string {
    // this needs to be explicitly typed here for some reason
    return (<GroupInviteLink>this).belongsTo('groupInvite').id();
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'group-invite-link': GroupInviteLink;
  }
}
